export default {
  id: 'uti',
  type: 'formulary',
  version: '12',
  children: [
    {
      type: 'section',
      children: [
        {
          id: 'reproduction.pregnant',
          version: '1',
          type: 'binary',
          validations: {
            required: true,
          },
          label: 'Är du gravid?',
          index: '0.0.0',
        },
        {
          id: 'reproduction.breastfeeding',
          version: '1',
          type: 'binary',
          validations: {
            required: true,
          },
          label: 'Ammar du?',
          index: '0.0.1',
        },
      ],
      version: '1',
      condition:
        "get('answers.predefined.gender') === 'female' && get('answers.predefined.age') < 50",
      index: '0.0',
    },
    {
      type: 'section',
      children: [
        {
          id: 'started',
          type: 'choice',
          version: '4',
          options: [
            {
              value: 'within24hours',
              label: 'Senaste dygnet',
            },
            {
              value: 'last2to4days',
              label: 'För 2–4 dagar sedan',
            },
            {
              value: 'moreThan4days',
              label: 'För mer än 4 dagar sedan',
            },
          ],
          validations: {
            required: true,
          },
          label: 'När började besvären?',
          index: '0.1.0',
        },
        {
          id: 'uti.backPain',
          version: '2',
          type: 'choice',
          options: [
            {
              value: 'both',
              label: 'Ja, på båda sidor',
            },
            {
              value: 'right',
              label: 'Ja, på höger sida',
            },
            {
              value: 'left',
              label: 'Ja, på vänster sida',
            },
            {
              value: 'no',
              label: 'Nej',
            },
          ],
          validations: {
            required: true,
          },
          label: 'Har du fått ont i ryggen i samband med dina urinvägsbesvär?',
          index: '0.1.1',
        },
        {
          id: 'health.fever',
          type: 'binary',
          version: '2',
          validations: {
            required: true,
          },
          label: 'Har du feber (över 38°C)?',
          index: '0.1.2',
        },
        {
          id: 'health.temperature',
          version: '4',
          type: 'number',
          condition: "get('answers.health.fever') === 'yes'",
          validations: {
            required: true,
          },
          label: 'Hur hög feber har du just nu?',
          unit: '°C',
          index: '0.1.3',
        },
        {
          id: 'medication.recentAgainstFever',
          version: '1',
          type: 'binary',
          condition: "get('answers.health.fever') === 'yes'",
          validations: {
            required: true,
          },
          label:
            'Har du tagit febernedsättande läkemedel under de senaste 4 timmarna?',
          index: '0.1.4',
        },
        {
          id: 'uti.recentAntibioticsYear.match',
          version: '1',
          type: 'binary',
          validations: {
            required: true,
          },
          label:
            'Har du behandlats med antibiotika mot urinvägsinfektion under de senaste 12 månaderna?',
          index: '0.1.5',
        },
        {
          id: 'uti.recentAntibioticsYear.frequency',
          version: '1',
          type: 'choice',
          options: [
            {
              value: 'once',
              label: 'En gång',
            },
            {
              value: 'twice',
              label: 'Två gånger',
            },
            {
              value: 'threeOrMore',
              label: 'Tre gånger eller fler',
            },
          ],
          condition: "get('answers.uti.recentAntibioticsYear.match') === 'yes'",
          validations: {
            required: true,
          },
          label:
            'Hur många gånger har du behandlats med antibiotika mot urinvägsinfektion under de senaste 12 månaderna?',
          index: '0.1.6',
        },
        {
          id: 'uti.recentAntibioticsYear.twiceInSixMonths',
          version: '1',
          type: 'binary',
          condition:
            "get('answers.uti.recentAntibioticsYear.frequency') === 'twice'",
          validations: {
            required: true,
          },
          label:
            'Har du fått båda dessa behandlingar under de senaste 6 månaderna?',
          index: '0.1.7',
        },
        {
          id: 'uti.recentAntibiotics',
          type: 'composite',
          version: '6',
          children: [
            {
              id: 'uti.recentAntibiotics.match',
              type: 'binary',
              relativeId: 'match',
              version: '6',
              validations: {
                required: true,
              },
              label:
                'Har du behandlats med antibiotika mot urinvägsinfektion under den senaste månaden?',
              index: '0.1.8.0',
            },
            {
              id: 'uti.recentAntibiotics.what',
              type: 'choice',
              options: [
                {
                  value: 'selexid',
                  label: 'Pivmecillinam (t.ex. Selexid, Penomax)',
                },
                {
                  value: 'cefadroxil',
                  label: 'Cefadroxil (t.ex. Cefamox)',
                },
                {
                  value: 'furadantin',
                  label: 'Nitrofurantoin (t.ex. Furadantin)',
                },
                {
                  value: 'trimetoprim',
                  label: 'Trimetoprim (t.ex. Idotrim)',
                },
                {
                  value: 'ciprofloxacin',
                  label: 'Ciprofloxacin (t.ex. Ciproxin)',
                },
                {
                  value: 'other',
                  label: 'Annat',
                },
              ],
              condition: "get('answers.uti.recentAntibiotics.match') === 'yes'",
              relativeId: 'what',
              version: '6',
              validations: {
                required: true,
              },
              label: 'Vilken sorts antibiotika fick du?',
              index: '0.1.8.1',
            },
            {
              id: 'uti.recentAntibiotics.other',
              type: 'text',
              condition:
                "get('answers.uti.recentAntibiotics.what') === 'other'",
              relativeId: 'other',
              version: '6',
              validations: {
                required: true,
              },
              label: 'Vilken sorts antibiotika fick du?',
              index: '0.1.8.2',
            },
            {
              id: 'uti.recentAntibiotics.when',
              type: 'choice',
              condition: "get('answers.uti.recentAntibiotics.match') === 'yes'",
              options: [
                {
                  value: 'within24hours',
                  label: 'Senaste dygnet',
                },
                {
                  value: 'last2to4days',
                  label: 'För 2–4 dagar sedan',
                },
                {
                  value: 'moreThan4days',
                  label: 'För mer än 4 dagar sedan',
                },
              ],
              relativeId: 'when',
              version: '6',
              validations: {
                required: true,
              },
              label: 'När påbörjade du behandlingen med antibiotika?',
              index: '0.1.8.3',
            },
          ],
          condition: "get('answers.uti.recentAntibioticsYear.match') === 'yes'",
          extras: {},
          index: '0.1.8',
        },
        {
          id: 'health.pyelonephritis.match',
          version: '1',
          type: 'binary',
          validations: {
            required: true,
          },
          label: 'Har du någon gång haft njurbäckeninflammation?',
          index: '0.1.9',
        },
        {
          id: 'uti.burnWhenPeeing',
          type: 'binary',
          version: '1',
          validations: {
            required: true,
          },
          label: 'Svider det när du kissar?',
          index: '0.1.10',
        },
        {
          id: 'uti.urgeToPee',
          type: 'binary',
          version: '3',
          validations: {
            required: true,
          },
          label:
            'Känner du dig kissnödig ofta utan att du egentligen behöver kissa?',
          index: '0.1.11',
        },
        {
          id: 'health.peeingOften.match',
          version: '1',
          type: 'binary',
          validations: {
            required: true,
          },
          label: 'Kissar du oftare än vanligt?',
          index: '0.1.12',
        },
        {
          id: 'uti.problemLevel',
          version: '1',
          type: 'choice',
          options: [
            {
              value: 'mild',
              label: 'Jag har lindriga besvär.',
            },
            {
              value: 'moderate',
              label: 'Jag har måttliga besvär.',
            },
            {
              value: 'severe',
              label: 'Jag har kraftiga besvär.',
            },
          ],
          validations: {
            required: true,
          },
          label: 'Hur upplever du dina urinvägsbesvär?',
          index: '0.1.13',
        },
        {
          id: 'uti.bloodInUrine.match',
          version: '5',
          type: 'choice',
          options: [
            {
              value: 'yesRed',
              label: 'Ja, urinen är rödfärgad.',
            },
            {
              value: 'yesLumps',
              label: 'Ja, jag har blodklumpar i urinen.',
            },
            {
              value: 'yesRedAndLumps',
              label:
                'Ja, jag har både rödfärgad urin och blodklumpar i urinen.',
            },
            {
              value: 'no',
              label: 'Nej',
            },
          ],
          validations: {
            required: true,
          },
          label: 'Har du synligt blod i urinen?',
          index: '0.1.14',
        },
        {
          id: 'uti.bloodInUrine.duration',
          version: '1',
          type: 'choice',
          options: [
            {
              value: 'within24hours',
              label: 'Senaste dygnet',
            },
            {
              value: 'twoToFourDays',
              label: '2–4 dagar',
            },
            {
              value: 'moreThanFourDays',
              label: 'I mer än 4 dagar',
            },
          ],
          condition:
            "get('answers.uti.bloodInUrine.match') === 'yesRed' || get('answers.uti.bloodInUrine.match') === 'yesLumps' || get('answers.uti.bloodInUrine.match') === 'yesRedAndLumps'",
          validations: {
            required: true,
          },
          label: 'Hur länge har du haft blod i urinen?',
          index: '0.1.15',
        },
        {
          id: 'uti.bloodInUrine.previous',
          version: '1',
          type: 'tertiary',
          condition:
            "get('answers.uti.bloodInUrine.match') === 'yesRed' || get('answers.uti.bloodInUrine.match') === 'yesLumps' || get('answers.uti.bloodInUrine.match') === 'yesRedAndLumps'",
          validations: {
            required: true,
          },
          label: 'Har du haft synligt blod i urinen tidigare?',
          index: '0.1.16',
        },
        {
          id: 'reproduction.period.match',
          version: '1',
          type: 'binary',
          condition:
            "( get('answers.uti.bloodInUrine.match') === 'yesRed' || get('answers.uti.bloodInUrine.match') === 'yesLumps' || get('answers.uti.bloodInUrine.match') === 'yesRedAndLumps' ) && get('answers.predefined.age') < 50",
          validations: {
            required: true,
          },
          label: 'Har du mens just nu?',
          index: '0.1.17',
        },
        {
          id: 'gastric.painLowerAbdomen',
          type: 'binary',
          version: '1',
          condition:
            "get('answers.uti.bloodInUrine.match') === 'yesRed' || get('answers.uti.bloodInUrine.match') === 'yesLumps' || get('answers.uti.bloodInUrine.match') === 'yesRedAndLumps'",
          validations: {
            required: true,
          },
          label: 'Har du ont i nedre delen av magen?',
          index: '0.1.18',
        },
        {
          id: 'uti.itching',
          type: 'binary',
          version: '3',
          validations: {
            required: true,
          },
          label:
            'Har du i samband med urinvägsbesvären också klåda i underlivet?',
          index: '0.1.19',
        },
        {
          id: 'uti.increasedDischarge',
          type: 'binary',
          version: '3',
          validations: {
            required: true,
          },
          label:
            'Har du i samband med urinvägsbesvären också ökade flytningar?',
          index: '0.1.20',
        },
        {
          id: 'uti.blisters',
          type: 'binary',
          version: '1',
          condition: "get('answers.uti.burnWhenPeeing') === 'yes'",
          validations: {
            required: true,
          },
          label:
            'Har du i samband med urinvägsbesvären också blåsor i underlivet?',
          index: '0.1.21',
        },
        {
          id: 'medication.containing.estrogen.ongoing.match',
          version: '1',
          type: 'binary',
          condition: "get('answers.predefined.age') >= 45",
          validations: {
            required: true,
          },
          label: 'Använder du något läkemedel med östrogen?',
          index: '0.1.22',
        },
        {
          id: 'uti.selfTest',
          type: 'choice',
          version: '2',
          options: [
            {
              value: 'positive',
              label: 'Ja, med positivt resultat',
            },
            {
              value: 'negative',
              label: 'Ja, med negativt resultat',
            },
            {
              value: 'no',
              label: 'Nej',
            },
          ],
          validations: {
            required: true,
          },
          label: 'Har du gjort ett självtest för urinvägsinfektion?',
          index: '0.1.23',
        },
        {
          id: 'uti.labtest.pictures',
          type: 'upload',
          version: '1',
          condition: "get('answers.uti.selfTest') === 'positive'",
          validations: {
            required: true,
          },
          label: 'Ladda upp en bild eller skärmdump på provresultatet du fått.',
          index: '0.1.24',
        },
        {
          id: 'problem.main',
          version: '2-uti',
          type: 'choice',
          options: [
            {
              value: 'uti',
              label: 'Jag misstänker att jag har urinvägsinfektion',
            },
            {
              value: 'other',
              label: 'Annat',
            },
          ],
          validations: {
            required: true,
          },
          label: 'Vilket är ditt huvudsakliga besvär?',
          index: '0.1.25',
        },
        {
          id: 'problem.mainOther',
          version: '1',
          type: 'text',
          condition: "get('answers.problem.main') === 'other'",
          validations: {
            required: true,
          },
          label: 'Beskriv vilket ditt huvudsakliga besvär är.',
          index: '0.1.26',
        },
        {
          id: 'doctor.desiredHelpChoice',
          version: '1',
          type: 'choice',
          options: [
            {
              value: 'treatment',
              label: 'Rådgivning och eventuell behandling',
            },
            {
              value: 'other',
              label: 'Annat',
            },
          ],
          validations: {
            required: true,
          },
          label: 'Vad skulle du vilja ha hjälp med?',
          index: '0.1.27',
        },
        {
          id: 'doctor.desiredHelp',
          type: 'text',
          version: '2',
          validations: {
            required: true,
            max: 250,
          },
          condition: "get('answers.doctor.desiredHelpChoice') === 'other'",
          label: 'Beskriv kortfattat vad du vill ha hjälp med.',
          index: '0.1.28',
        },
        {
          id: 'healthProfile.info',
          version: '1',
          type: 'info',
          validations: {
            required: false,
          },
          description:
            '  <p>\n    Nu har du bara hälsoprofilen kvar.\n  </p>\n\n  <p>\n    Hälsoprofilen är till för att ge den som behandlar dig en bild av din allmänna hälsostatus.\n  </p>',
          index: '0.1.29',
        },
        {
          id: 'occupation.current',
          version: '2',
          type: 'composite',
          children: [
            {
              id: 'occupation.current.what',
              type: 'choice',
              options: [
                {
                  value: 'working',
                  label: 'Arbetar',
                },
                {
                  value: 'student',
                  label: 'Studerar',
                },
                {
                  value: 'sicklisted',
                  label: 'Sjukskriven',
                },
                {
                  value: 'parentalleave',
                  label: 'Föräldraledig',
                },
                {
                  value: 'retired',
                  label: 'Pensionär',
                },
                {
                  value: 'jobseeking',
                  label: 'Arbetssökande',
                },
                {
                  value: 'other',
                  label: 'Annat',
                },
              ],
              expires: 180,
              relativeId: 'what',
              version: '2',
              validations: {
                required: true,
              },
              label: 'Vad är din huvudsakliga sysselsättning?',
              index: '0.1.30.0',
            },
            {
              id: 'occupation.current.other',
              type: 'text',
              condition: "get('answers.occupation.current.what') === 'other'",
              expires: 900,
              relativeId: 'other',
              version: '2',
              validations: {
                required: true,
              },
              label: 'Beskriv din huvudsakliga sysselsättning.',
              index: '0.1.30.1',
            },
          ],
          extras: {},
          index: '0.1.30',
        },
        {
          id: 'work.what',
          type: 'text',
          version: '3',
          expires: 180,
          condition: "get('answers.occupation.current.what') === 'working'",
          validations: {
            required: true,
          },
          label: 'Vad arbetar du med?',
          index: '0.1.31',
        },
        {
          id: 'occupation.sicklisted',
          version: '1',
          type: 'text',
          expires: 90,
          condition: "get('answers.occupation.current.what') === 'sicklisted'",
          validations: {
            required: true,
          },
          label: 'Varför är du sjukskriven?',
          index: '0.1.32',
        },
        {
          id: 'occupation.sicklistedSince',
          version: '1',
          type: 'text',
          expires: 90,
          condition: "get('answers.occupation.current.what') === 'sicklisted'",
          validations: {
            required: true,
          },
          label: 'Vilket datum började din senaste sjukskrivningsperiod?',
          index: '0.1.33',
        },
        {
          id: 'height',
          type: 'number',
          version: '2',
          unit: 'cm',
          validations: {
            required: true,
            min: 50,
            max: 300,
          },
          expires: 99999,
          label: 'Hur lång är du?',
          index: '0.1.34',
        },
        {
          id: 'weight',
          type: 'number',
          version: '2',
          unit: 'kg',
          validations: {
            required: true,
            min: 20,
            max: 700,
          },
          expires: 180,
          label: 'Hur mycket väger du?',
          index: '0.1.35',
        },
        {
          id: 'smoking.status',
          type: 'choice',
          version: '1',
          options: [
            {
              value: 1,
              label: 'Ja',
            },
            {
              value: 2,
              label: 'Nej',
            },
            {
              value: 3,
              label: 'Före detta',
            },
          ],
          expires: 180,
          validations: {
            required: true,
          },
          label: 'Är du rökare?',
          index: '0.1.36',
        },
        {
          id: 'smoking.amount',
          type: 'choice',
          version: '1',
          options: [
            {
              value: 'lessthan10',
              label: 'Färre än tio',
            },
            {
              value: 'more',
              label: 'Tio eller fler',
            },
          ],
          expires: 180,
          condition: "get('answers.smoking.status') === 1",
          validations: {
            required: true,
          },
          label: 'Hur många cigaretter röker du per dag?',
          index: '0.1.37',
        },
        {
          id: 'alcohol.amountFemale',
          type: 'choice',
          version: '2',
          options: [
            {
              value: 'more',
              label: '9 standardglas i veckan eller mer',
            },
            {
              value: 'less',
              label: 'Mindre än 9 standardglas i veckan',
            },
            {
              value: 'none',
              label: 'Jag dricker inte alkohol',
            },
          ],
          expires: 180,
          condition: "get('answers.predefined.gender') !== 'male'",
          validations: {
            required: true,
          },
          label: 'Hur mycket alkohol dricker du?',
          description:
            'Ett standardglas motsvarar ett glas vin, en flaska starköl (33 cl) eller 4 cl starksprit.',
          index: '0.1.38',
        },
        {
          id: 'alcohol.amountMale',
          type: 'choice',
          version: '2',
          options: [
            {
              value: 'more',
              label: '14 standardglas i veckan eller mer',
            },
            {
              value: 'less',
              label: 'Mindre än 14 standardglas i veckan',
            },
            {
              value: 'none',
              label: 'Jag dricker inte alkohol',
            },
          ],
          expires: 180,
          condition: "get('answers.predefined.gender') === 'male'",
          validations: {
            required: true,
          },
          label: 'Hur mycket alkohol dricker du?',
          description:
            'Ett standardglas motsvarar ett glas vin, en flaska starköl (33 cl) eller 4 cl starksprit.',
          index: '0.1.39',
        },
        {
          id: 'health.issues.what',
          version: '2',
          type: 'multipleChoice',
          options: [
            {
              value: 'bloodpreassure',
              label: 'Högt blodtryck med tablettbehandling',
            },
            {
              value: 'cardiovascular',
              label: 'Hjärt-kärlsjukdom',
            },
            {
              value: 'diabetes',
              label: 'Diabetes',
            },
            {
              value: 'lungs',
              label: 'Lungsjukdom',
            },
            {
              value: 'cancer',
              label: 'Cancersjukdom',
            },
            {
              value: 'neuro',
              label: 'Neurologisk sjukdom',
            },
            {
              value: 'blooddisease',
              label: 'Blodsmitta (HIV, Hepatit B, Hepatit C)',
            },
            {
              value: 'kidney',
              label: 'Njurfunktionsnedsättning',
            },
            {
              value: 'liver',
              label: 'Leverfunktionsnedsättning',
            },
          ],
          expires: 900,
          validations: {
            required: false,
          },
          label:
            'Markera de sjukdomar eller hälsoproblem du har, eller har haft.',
          description: 'Flera svarsalternativ möjliga.',
          index: '0.1.40',
        },
        {
          id: 'health.cardiovascular.what',
          type: 'composite',
          version: '1',
          children: [
            {
              id: 'health.cardiovascular.what.what',
              type: 'multipleChoice',
              options: [
                {
                  value: 'infarction',
                  label: 'Hjärtinfarkt',
                },
                {
                  value: 'congestiveHeart',
                  label: 'Hjärtsvikt',
                },
                {
                  value: 'anginaPectoris',
                  label: 'Kärlkramp',
                },
                {
                  value: 'atrialFibrillation',
                  label: 'Förmaksflimmer',
                },
                {
                  value: 'heartValve',
                  label: 'Hjärtklaffsfel',
                },
                {
                  value: 'stroke',
                  label: 'Stroke',
                },
                {
                  value: 'bloodClot',
                  label: 'Blodpropp som krävt blodförtunnande medicinering',
                },
                {
                  value: 'other',
                  label: 'Annan hjärt-kärlsjukdom',
                },
              ],
              validations: {
                required: true,
              },
              expires: 900,
              relativeId: 'what',
              version: '1',
              label: 'Vilka hjärt-kärlsjukdomar har du, eller har du haft?',
              index: '0.1.41.0',
            },
            {
              id: 'health.cardiovascular.what.other',
              type: 'text',
              condition:
                "contains(get('answers.health.cardiovascular.what.what'), 'other')",
              expires: 900,
              relativeId: 'other',
              version: '1',
              validations: {
                required: true,
              },
              label: 'Vilken hjärt-kärlsjukdom har du, eller har du haft?',
              index: '0.1.41.1',
            },
          ],
          condition:
            "contains(get('answers.health.issues.what'), 'cardiovascular')",
          extras: {},
          index: '0.1.41',
        },
        {
          id: 'health.diabetes.type',
          version: '1',
          type: 'multipleChoice',
          options: [
            {
              value: 'type1',
              label: 'Diabetes typ 1',
            },
            {
              value: 'type2',
              label: 'Diabetes typ 2',
            },
            {
              value: 'other',
              label: 'Annat',
            },
          ],
          expires: 900,
          validations: {
            required: true,
          },
          condition: "contains(get('answers.health.issues.what'), 'diabetes')",
          label: 'Vilken typ av diabetes har du?',
          description: 'Flera svarsalternativ möjliga.',
          index: '0.1.42',
        },
        {
          id: 'health.diabetes.typeOther',
          version: '1',
          type: 'text',
          expires: 900,
          condition: "contains(get('answers.health.diabetes.type'), 'other')",
          validations: {
            required: true,
          },
          label: 'Vilken typ av diabetes har du?',
          index: '0.1.43',
        },
        {
          id: 'health.diabetes.treatment',
          version: '2',
          type: 'multipleChoice',
          options: [
            {
              value: 'food',
              label: 'Kostbehandling',
            },
            {
              value: 'pills',
              label: 'Tablettbehandling',
            },
            {
              value: 'insuline',
              label: 'Insulinbehandling',
            },
          ],
          expires: 900,
          validations: {
            required: true,
          },
          condition: "contains(get('answers.health.issues.what'), 'diabetes')",
          label: 'Hur behandlas du för din diabetes?',
          description: 'Flera svarsalternativ möjliga.',
          index: '0.1.44',
        },
        {
          id: 'health.lungDiseases.what',
          type: 'composite',
          version: '1',
          children: [
            {
              id: 'health.lungDiseases.what.what',
              type: 'multipleChoice',
              options: [
                {
                  value: 'astma',
                  label: 'Astma',
                },
                {
                  value: 'kol',
                  label: 'KOL',
                },
                {
                  value: 'other',
                  label: 'Annan lungsjukdom',
                },
              ],
              validations: {
                required: true,
              },
              expires: 900,
              relativeId: 'what',
              version: '1',
              label: 'Vilka lungsjukdomar har du, eller har du haft?',
              description: 'Flera svarsalternativ möjliga.',
              index: '0.1.45.0',
            },
            {
              id: 'health.lungDiseases.what.other',
              type: 'text',
              condition:
                "contains(get('answers.health.lungDiseases.what.what'), 'other')",
              expires: 900,
              relativeId: 'other',
              version: '1',
              validations: {
                required: true,
              },
              label: 'Vilken lungsjukdom har du, eller har du haft?',
              index: '0.1.45.1',
            },
          ],
          condition: "contains(get('answers.health.issues.what'), 'lungs')",
          extras: {},
          index: '0.1.45',
        },
        {
          id: 'health.cancerWhat',
          type: 'text',
          expires: 900,
          version: '1',
          condition: "contains(get('answers.health.issues.what'), 'cancer')",
          validations: {
            required: true,
          },
          label: 'Vilken cancersjukdom har du, eller har du haft?',
          index: '0.1.46',
        },
        {
          id: 'health.cancerYearDiagnosed',
          type: 'text',
          version: '1',
          expires: 900,
          condition: "contains(get('answers.health.issues.what'), 'cancer')",
          validations: {
            required: true,
          },
          label: 'Vilket år fick du din cancerdiagnos?',
          index: '0.1.47',
        },
        {
          id: 'health.cancerAffected.match',
          type: 'binary',
          version: '1',
          expires: 900,
          condition: "contains(get('answers.health.issues.what'), 'cancer')",
          validations: {
            required: true,
          },
          label: 'Är ditt hälsotillstånd i dagsläget påverkat av din cancer?',
          index: '0.1.48',
        },
        {
          id: 'health.cancerAffected.how',
          type: 'text',
          version: '1',
          expires: 900,
          condition: "get('answers.health.cancerAffected.match') === 'yes'",
          validations: {
            required: true,
          },
          label:
            'På vilket sätt är ditt hälsotillstånd i dagsläget påverkat av din cancer?',
          index: '0.1.49',
        },
        {
          id: 'health.neurological.what',
          type: 'composite',
          version: '1',
          children: [
            {
              id: 'health.neurological.what.what',
              type: 'multipleChoice',
              options: [
                {
                  value: 'epilepsy',
                  label: 'Epilepsi',
                },
                {
                  value: 'ms',
                  label: 'MS',
                },
                {
                  value: 'parkinson',
                  label: 'Parkinson',
                },
                {
                  value: 'other',
                  label: 'Annan neurologisk sjukdom',
                },
              ],
              validations: {
                required: true,
              },
              expires: 900,
              relativeId: 'what',
              version: '1',
              label: 'Vilka neurologiska sjukdomar har du, eller har du haft?',
              index: '0.1.50.0',
            },
            {
              id: 'health.neurological.what.other',
              type: 'text',
              condition:
                "contains(get('answers.health.neurological.what.what'), 'other')",
              expires: 900,
              relativeId: 'other',
              version: '1',
              validations: {
                required: true,
              },
              label: 'Vilken neurologisk sjukdom har du, eller har du haft?',
              index: '0.1.50.1',
            },
          ],
          condition: "contains(get('answers.health.issues.what'), 'neuro')",
          extras: {},
          index: '0.1.50',
        },
        {
          id: 'health.bloodDisease.what',
          version: '1',
          type: 'multipleChoice',
          options: [
            {
              value: 'hepB',
              label: 'Hepatit B',
            },
            {
              value: 'hepC',
              label: 'Hepatit C',
            },
            {
              value: 'hiv',
              label: 'HIV',
            },
          ],
          validations: {
            required: true,
          },
          expires: 900,
          condition:
            "contains(get('answers.health.issues.what'), 'blooddisease')",
          label: 'Vilken blodsmitta har du, eller har du haft?',
          index: '0.1.51',
        },
        {
          id: 'health.operation.match',
          type: 'binary',
          version: '1',
          expires: 900,
          validations: {
            required: true,
          },
          label: 'Har du genomgått någon större operation?',
          index: '0.1.52',
        },
        {
          id: 'health.operation.what',
          type: 'text',
          version: '1',
          expires: 900,
          condition: "get('answers.health.operation.match') === 'yes'",
          validations: {
            required: true,
          },
          label: 'Vilken större operation har du genomgått?',
          index: '0.1.53',
        },
        {
          id: 'health.relativesCancer',
          type: 'tertiary',
          version: '1',
          expires: 900,
          validations: {
            required: true,
          },
          label:
            'Har någon av dina (biologiska) föräldrar eller syskon drabbats av cancer?',
          index: '0.1.54',
        },
        {
          id: 'health.relativesCardiovascular',
          type: 'tertiary',
          version: '1',
          expires: 900,
          validations: {
            required: true,
          },
          label:
            'Har någon av dina (biologiska) föräldrar eller syskon drabbats av hjärt-kärlsjukdom?',
          index: '0.1.55',
        },
        {
          id: 'health.relativesDiabetes',
          type: 'tertiary',
          version: '1',
          expires: 900,
          validations: {
            required: true,
          },
          label:
            'Har någon av dina (biologiska) föräldrar eller syskon drabbats av diabetes?',
          index: '0.1.56',
        },
        {
          id: 'medication.current',
          type: 'composite',
          version: '4',
          children: [
            {
              id: 'medication.current.anyFemale',
              type: 'binary',
              condition: "get('answers.predefined.gender') === 'female'",
              expires: 180,
              relativeId: 'anyFemale',
              version: '4',
              validations: {
                required: true,
              },
              label: 'Använder du några läkemedel för tillfället?',
              description:
                'Om du använder hormonella preventivmedel bör även detta uppges.',
              index: '0.1.57.0',
            },
            {
              id: 'medication.current.anyMale',
              type: 'binary',
              condition: "get('answers.predefined.gender') === 'male'",
              expires: 180,
              relativeId: 'anyMale',
              version: '4',
              validations: {
                required: true,
              },
              label: 'Använder du några läkemedel för tillfället?',
              index: '0.1.57.1',
            },
            {
              id: 'medication.current.what',
              type: 'text',
              condition:
                "get('answers.medication.current.anyFemale') === 'yes' || get('answers.medication.current.anyMale') === 'yes'",
              expires: 180,
              relativeId: 'what',
              version: '4',
              validations: {
                required: true,
              },
              label: 'Vilka läkemedel tar du?',
              description:
                'Ange läkemedel, styrka och dos, t.ex. Levaxin, 100 mikrogram, 1 tablett 1 gång/dag. Om du vet av vilken anledning du tar läkemedlet, ange detta.',
              index: '0.1.57.2',
            },
          ],
          extras: {},
          index: '0.1.57',
        },
        {
          id: 'medication.packaged',
          type: 'binary',
          version: '3',
          expires: 180,
          condition: "get('answers.medication.current.anyFemale') === 'yes'",
          validations: {
            required: true,
          },
          label:
            'Får du dina läkemedel i färdiga dosförpackningar/-påsar, t.ex. Apodos?',
          description:
            '  <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGIAAABiCAYAAACrpQYOAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAA/kSURBVHgB7Z0JcBR\n  lFsdf90wwQs7dWgVkl3AqiJJAAauFEMELsFROqS2BBNwLEkB0Vw5dgqXR8uAWLZVcurtyCHgRlfsoVCxysK5YgmSw2CRaVuWYYOKSTPv+X08nc99HJ8yvqpnpnm9Cz/f6nd39WiIdU1dXl8Iv6UajcbjFQv0kifoqCq\n  URKSmSJOGzFIev1CuKUs+fmbDCYytlmapaW1srebUiNTW1nnSKRDqCJz6NJ/1+RZHSFcWSKctyGi+E5b1P9tPQQYNo6PUDiSdajMfrvMV/ozkzp9Idt93KE6+I7Za160mpribLtT15uYYsAwaIRUlIMLF4KmRZ2nP58u\n  UjLBgT6QQjRRnr5M/jOczkic00Gg1kMBiIt7VPOGj5+f/0/v6DNGzIYLvvT2QBfFFxWghCG2/4w2yiNwqIvvyS6LMmotvGEjU0kGXS3WltbW1YHoDMGhrMLBQqYo15V09CiRgwOWazeUljo/mQ2dykNDe3KDwZiicu1t\n  QqE2fOaV8/c/acUrx9lzI39zG77f6A/7O5uVnBPmBfmpqa5lGUiKhpggD4SF/CR+NSPupTrrqqmzj6fWXM5Gk0ceytdOD4CUpISBBagPXcVXm0q+AVuq7ntRQoLBS6fLmVX9tMbNz2sNZs6HJaYtWA1Rera+pw9FssFi\n  UQlue/oCxauVq5WF3rtB3aERSnyhRlYY7S9tBcpXnnLmgIL03rYDopAsgUZiAAg8FY9e/dH+RtLngrJT7+Kjvb7w+j028mKPF1va512n6S/UTAVNcQLV9BVFZO8rlvKf7Fl6jH4SMUF2dgzTUeamhoWEphJmyC4CMpk2\n  1vOZuhvKfWbU5Z+3ohjR4xnIIBpuhk+Wmft9thblIXV5w96/SZXFFB8fHx1KNH97Ru3bqtY+04H07tCLkgYIYaGxvX4UhihU/HtlOn/ys+GzKoPwVDIvuFIQP786RXOm1PSuhB/6v93vlLONoX5RLddY+6TJtB9OFe+z\n  E9ezp/b0SGeEHoDIHEx3frZzTGnYeGUxgIqSBwxBgMceVsPtpV+ZvzVVTzww/Ckd4wcAAFy6iM4U5mCALAksQCsQNCyMkVJkeQmEhUU0v0dD7Rtu0d467nkHjB/I71kSOIxt1m96fi4uKoe/erpZ9aWvLCoR0hEwRCP9\n  YC/sVKmu32Mqs2jMq4mULB1El30ps7dlMJL8DcdIlW5r9IczmpS2StsOPIMXXie/cm+qRUXRYvVj/bWmhvjh6er36+awfR5o2q0ByQWDvWv1ZEa18r6HepuaUslL4jJIKAunIgVETOJQc6/NlJ8YowMxRAsxCq7j92go\n  aMu5vumDVHaMmK3L/YD0TGduwY0m+iVSs6Jnb2TCLO0PnIIaqtsf8OxvTq5f4/578Jbdz23gd0tsqUKkny2lCZqqAza/YHhbx/We4+P3veJF6HDAreLGlAGCUbX/A+MDFBFQicsdXmC5rM6qs75+0GWxM48qZh2CQhGG\n  FT1TcpKWE+BUHAGqE6ZfMh3pcsd2PgpM2XLrFv6O9sv8MNNAGlDQB/AAddwxqwYZNqrnDk2wrHB7TIbMSwoQ6fKNlcLimzFikDIiCNUDPkuPaoyB2DB6TR808+TnFcP/r0VDkL5kthQrToJphM2CfuncI110pVCHDQGh\n  DS4hzyByjWweOfivfjbhnt9Dn/yQxZNh7kuZkQSJU3oMxKzQ88C8EVXPUUJY1XS94W1dQtz60RkdRJnqwhAwc6O9tQAUF8yI64ljUhg3d79izVT/gB/16688F5VP39D7Rn6xbqxVVdNxxKSkqcQH7ityDgEzyZI39AjA\n  7BPPzoCvqm6gKd3PsOm+0mOsPZ7ej04JK/UHPm7Lc0bcFC6t3zGhbEK15GS4X++gy/TBMiBE+O2V+45iSWV557Sqz/9FMznf/uIj2zfgufdxhEz654TJgxCCcUOUgwaLlLxrAbfRitZPFcXUhMTFxDPuKzs0bZGhEChR\n  GueFL/3/ahtza9RKty/0pcIKQTJ0/RwuWraXfpPjEGZsxlBh1GYJYOcrgM85H5+9G+fAXR1OqGBt/L6j6ZJjVjRrJGAUcFwaL5lxe2vEHv7ztIB3a8KXxK2P0LqYIYOv4eUaz04h8cqWtrax3hSzndJ43gsgWHqdETAu\n  CEUZwvWPrHLDqwvYQM7F++NX1HG18vpkUr88QYaAoEE2o0szS4f5o/QgCpPHcHfQlrvfoI1S/Yly30AMzYNb/+lfAvOFLhX05/9TVHZP+i6VPuESWPr9npoyAYbJisha2++QdHlH4sjH/wm2WeRnnUCJikcPuFUADTAc\n  GMHTVS+Jfpk++ilpYW+ujgUZqb85gQCAjEv+Bvf80RE1KP8beMosBQltbVmTM9jfDoIzh1r3Is4nVG1CtBJFq2Op++//FHUatSyxW1XsPkRrOZxkyZIbRu/7ZiSuwRmC9ieZYnJyeOcPe5W9OkRkmdXwhADZNJZPkAZu\n  znlp+Ff/ldn96Uv6JDaxzDZK2sMfKmoQELASDz5mptXnJycp6rz12aJtUkSWE/PRgtYMZ+Y/UvK61hMvzL408/337SCWaskUvs7WWNMT6FrR7hau1id47bpSA4TFzSFUySL8AH4AqOSbePF/7lxsEDqZn9y873Simh+9\n  WsKeeFfxjEdbMQkMpm0uUB7iQI9cxT8Nowesp0sSRyKVp7xTKVywRYb+SqrO06yhpYz1m1RqzvP35CrOdvflWsF+/cLdbxaruOcVjHOKx/hfIIr+c88ZRYb+CsHOvTHl5ktz7m3hliPYHzD20d+9S9e3e6b96facmfso\n  VfOCNMlqSVvYPGnVY4OWtcQgIvT0GCHwfOHP2YOiu2idznH+ykUKEoljWOvsKVaXqAYoQVV1phJwiurGZdKb4hyqSwr8iy3eCgEVLUrv28wmBrJ99nu6FdENbLQzIpRqTItL0kp10QrCox3xBZJFvzZCuImFmKMGyexm\n  nvRYnDWtzz+xx0oFRW/ocizfDhN5EOEeYJ5yuERnAmnUkxooLmEqxFP+l+iiA6PTqjAUdPBnEtqtVHSBEzSzGcyMQ/sprhxZK46KGkiQv2+F3EtSHmrB0xprOvkGNmKcrIsiUdGpFGESbmrO1ABbyvzEmFvq5tvALhs6\n  FpYb+rNIZ3OIbtK8cipuiDBi8sCCmqV/DFAAoEQTFBRJ+UmI/QCTFB6ISYIHQCBKHb9mpXEPWcWSv1XTZywq2gaP+AK8B79VRvZAywM054keqNHMPWW1vhdR3wg3Av9TP5HX04APprPLFKvRFeVygmmffZRF2JRjPR+o\n  1E02faCwEcPUa0fTvpERaE5QJ1BTS1zsrmyd7hftzeUtIbLINKOGsTdWYggFNlqgag1cOsWZ7Hu+g64wntti/c6B4mcASZZItFrqDOyjdniXIWqwt8AlqMwg9kuOmxAUed4V//jUjAMoBGtHZOQTg2xQJo/bOB/cPSXO\n  fxEAKaoMzPIv3RWiGrDTwUE+kMXBIvFncD0OTEVZufY8fV7bYdydA4C82w3DTEiib8G02QgdG6coTD2DTSCbtLP6E9pfvErVPo4bcw+yHq08uh7155uesvw2cgbN28SRUKTNWCbNIr6F+OV63EoRvz9HLhW7Sl6J+0KH\n  sOPbviUerNAsha8nfRMs4OT7YeCdy5c0TFBboWAqPIsix64glBWCyWPaQTSnbsoqINz9PojJvphkEDKIe1Af2/NxeU2A+c7SI6gh9AY8TiAqfmiE4g3zhVrr5Gkba2y0fxKgRh7RVxmKIM7n121SkAwtjz0T77NqMiS1\n  5JNHgwUVKSKgDND3jrxfT6VqK7J6nOHnkHWs1FATZLFVqfDrljo+UIRRn0bkVLoIs19t0BIJxF2XOF2bJjymT16P94ryoAX1rDmVkDCgo71hH2or1c5GFnZinWVtoFweapiKIMJnzOzGn03KZXnT6bO1O9fUNrFxQwZh\n  emqMm/Jouhguf8Xe19uyD0Yp7m8YSjC4CtGUIYiz6vyG5fLnzT2XH7A5oq2jp6+BVv/iQ8HLZtH2R3YojN07sUZaAVaMAIMwQBfM4CmbZgER04/qlw4mjkW8wO3StwwoePOjtkTPyT7Fsms48YP46TP87K50c8smKzJB\n  XZbrArzuNiWHS2pxBcUBDsfdZ4ZA2AFjyz/FERRQH4kKnzFwqhOOUWAHkESh22fgDjHpylLn5g21Bx99Yt1Nu/Xk2e/m5VcnJSf9ttdhqBDI+1YgPpAGgFGlZpoawGNOaBSXfRqmdfcv1FTQhaKAszpDnksnLSA5IkO6\n  ULTues2YGsJx2cPkUOgeZXJdudzRDCWfgRraOMHaWlqhAQ2iKS2rJJ1QRoytYC0gEK5w4bHTc6CUJPWqHlD2j16cio9OFOYa7odCy6HPdUfYDGrBnqK/q+RhdYO5ePzHF5FYdetELLHxDO2hb/RFcx1oY+Dk9WaS/oQR\n  jVNdpg+8cWRBEU+CyWVpcHuUtB6EkrkD+Ihvf5L4pOMZ9XVFLuqjWi7OHUCxb9xxGKYvKRNb+9TTVHGzep5mrWTIoivFOy2wdIebykAY3H0XmLAiCU3WkQKW3mcPaLCvVOowljbxFmy/VgDlWzFrBGVHdsgxCQhePxBX\n  4QyqiJ/9Z5jpTcdhH22OXSYqFlBgMdoiij5Ra+DWbz8461Oz7O4GkJ24iAjqdQoVgsbRM9DfAoiNTUxMOsFev5t3S+tnLQgCmkB6BYa7w14fV6ySU7lzVIQChGQKjJm/ce4V4FAcfNajWB39ZRDL9gIdR5M0kaPl2EDL\n  Vqa1OWUQx/QJTk1SRp+PzYgtTUpCL2F2nsL/x6uJHSia/nDGLPhV9ITk7wOQXw6/kRbOvyGhoa+0qS7w/yQHPCzo6fj/TEk0+LOVT1+dkRwO9nDPF/kN3YaO7Lb2/3NC7Q55F2dtTW00l+19UDmi2Uy/Fgo0CTva4KC6\n  GMo8yJgTzsKaA7htRIqnUCpE8xANzJoUCFAIK2H+wzCv3xGV0QzScEdZov6HvosAOIECioIKPTYo2OghMCCJlHratrWGowyHhySCpdASBZ4zNtjyQlJRRTCAhpaINGgbJsYCcu9aOuC0xRFTJmX5M1Xwjp7b3YMZwU78\n  KmSpxhYyGMDKUQQNiCfRvtSAvn/xMhIIAKPi3wCFekw3JFZNgnCL5DlqXFndRcwQzh9ucNvlRQgyEiR6qqHcYlnAAuoc6hHe0CwDnmQHMDf4jopGgC4d95v05NVsQFoBG1iaira8wyGKS51NGhP1r7ogUVh9kP7GEBlE\n  RSABpRPyKtWoJOzPPYdGkdN8O9X7aTf8RiMRanpl5toiiiK9OgPk/BkMmach8eXO5wX1+g+9oeRuO6Ik7CePKVimgd+e7QteNUuzSjOS2hEydOSomOnNYHFaagF57teNW+48I4qZ7Hmvhov8DrnHzRadxCq6eJd+QXhy\n  79Nra9PxkAAAAASUVORK5CYII=" height="100"/>',
          modal: {
            link: 'Vad innebär färdiga dosförpackningar/-påsar?',
            content:
              '  <p>\n    Vi syftar på små, färdigförpackade påsar med läkemedel som ska tas vid ett och samma tillfälle, där varje påse är märkt med personuppgifter, vilka läkemedel den innehåller samt datum och tid för när dessa ska tas.\n  </p>',
          },
          index: '0.1.58',
        },
        {
          id: 'medication.deliveryHelp.match',
          type: 'binary',
          version: '3',
          expires: 180,
          condition: "get('answers.medication.current.anyFemale') === 'yes'",
          validations: {
            required: true,
          },
          label:
            'Får du särskild hjälp med utdelning av dina läkemedel av hemtjänst, vårdcentral, mottagning eller liknande?',
          index: '0.1.59',
        },
        {
          id: 'medication.deliveryHelp.what',
          type: 'text',
          version: '2',
          expires: 180,
          condition: "get('answers.medication.deliveryHelp.match') === 'yes'",
          validations: {
            required: true,
          },
          label: 'Beskriv vilken typ av hjälp med utdelning du får.',
          index: '0.1.60',
        },
        {
          id: 'medication.naturopathic',
          type: 'composite',
          version: '1',
          children: [
            {
              id: 'medication.naturopathic.any',
              type: 'binary',
              expires: 180,
              relativeId: 'any',
              version: '1',
              validations: {
                required: true,
              },
              label:
                'Använder du några natur- eller hälsokostpreparat för tillfället?',
              index: '0.1.61.0',
            },
            {
              id: 'medication.naturopathic.what',
              type: 'text',
              condition: "get('answers.medication.naturopathic.any') === 'yes'",
              expires: 180,
              relativeId: 'what',
              version: '1',
              validations: {
                required: true,
              },
              label: 'Vilka natur- eller hälsokostpreparat tar du?',
              index: '0.1.61.1',
            },
          ],
          extras: {},
          index: '0.1.61',
        },
        {
          id: 'allergy.penicillinMatch',
          type: 'choice',
          version: '1',
          options: [
            {
              value: 'yesKnows',
              label:
                'Ja, och jag vet vilken sorts penicillin eller antibiotika jag är allergisk mot.',
            },
            {
              value: 'yesDontKnow',
              label:
                'Ja, men jag vet inte vilken sorts penicillin eller antibiotika jag är allergisk mot.',
            },
            {
              value: 'no',
              label: 'Nej',
            },
            {
              value: 'dontKnow',
              label: 'Vet ej',
            },
          ],
          expires: 180,
          validations: {
            required: true,
          },
          label: 'Är du allergisk mot penicillin eller annan antibiotika?',
          index: '0.1.62',
        },
        {
          id: 'allergy.penicillinWhat',
          type: 'multipleChoice',
          version: '1',
          options: [
            {
              value: 'penicillins',
              label:
                'Penicilliner (t.ex. Amimox, Amoxicillin, Avopenin, Bioclavid, Calciopen, Flukloxacillin, Imacillin, Heracillin, Klaximol, Kåvepenin, Penomax, Selexid, Spektramox, Tikacillin)',
            },
            {
              value: 'azitromycin',
              label: 'Azitromycin (t.ex. Azitromax)',
            },
            {
              value: 'cefadroxil',
              label: 'Cefadroxil (t.ex. Cefamox)',
            },
            {
              value: 'ciprofloxacin',
              label: 'Ciprofloxacin (t.ex. Ciproxin)',
            },
            {
              value: 'erytromycin',
              label: 'Erytromycin (t.ex. Abboticin, Ery-Max)',
            },
            {
              value: 'klindamycin',
              label: 'Klindamycin (t.ex. Dalacin)',
            },
            {
              value: 'nitrofurantoin',
              label: 'Nitrofurantoin (t.ex. Furadantin)',
            },
            {
              value: 'norfloxacin',
              label: 'Norfloxacin (t.ex. Lexinor)',
            },
            {
              value: 'sulfa',
              label:
                'Sulfa (t.ex. Bactrim, Bactrim forte, Eusaprim, Eusaprim forte)',
            },
            {
              value: 'tetracykliner',
              label:
                'Tetracykliner (t.ex. Doxyferm, Lymelysal, Tetracyklin, Tetralysal)',
            },
            {
              value: 'trimetoprim',
              label: 'Trimetoprim (t.ex. Idotrim)',
            },
            {
              value: 'other',
              label: 'Annat',
            },
          ],
          expires: 180,
          validations: {
            required: true,
          },
          condition: "get('answers.allergy.penicillinMatch') === 'yesKnows'",
          label:
            'Vilken typ av penicillin eller annan antibiotika är du allergisk mot?',
          description: 'Flera svarsalternativ möjliga.',
          index: '0.1.63',
        },
        {
          id: 'allergy.penicillinOther',
          type: 'text',
          version: '1',
          expires: 180,
          condition: "contains(get('answers.allergy.penicillinWhat'), 'other')",
          validations: {
            required: true,
          },
          label:
            'Vilken typ av penicillin eller annan antibiotika är du allergisk mot?',
          index: '0.1.64',
        },
        {
          id: 'allergy.penicillinReaction',
          type: 'multipleChoice',
          version: '1',
          options: [
            {
              value: 'severe',
              label:
                'Allvarlig reaktion med t.ex. andningssvårigheter och svullnad i mun och svalg',
            },
            {
              value: 'light',
              label: 'Lättare besvär såsom hudutslag och klåda',
            },
            {
              value: 'other',
              label: 'Annat',
            },
          ],
          expires: 180,
          validations: {
            required: true,
          },
          condition: "contains(get('answers.allergy.penicillinMatch'), 'yes')",
          label: 'Hur reagerade du på penicillinet/antibiotikan?',
          description: 'Flera svarsalternativ möjliga.',
          index: '0.1.65',
        },
        {
          id: 'allergy.penicillinReactionOther',
          type: 'text',
          version: '1',
          expires: 180,
          condition:
            "contains(get('answers.allergy.penicillinReaction'), 'other')",
          validations: {
            required: true,
          },
          label: 'Beskriv hur du reagerade på penicillinet/antibiotikan.',
          index: '0.1.66',
        },
        {
          id: 'allergy.medication',
          type: 'composite',
          version: '4',
          children: [
            {
              id: 'allergy.medication.any',
              type: 'tertiary',
              expires: 180,
              relativeId: 'any',
              version: '4',
              validations: {
                required: true,
              },
              label:
                'Förutom penicillin eller annan antibiotika, finns det andra läkemedel som du vet att du är allergisk mot, eller har fått biverkningar av?',
              index: '0.1.67.0',
            },
            {
              id: 'allergy.medication.what',
              type: 'text',
              condition: "get('answers.allergy.medication.any') === 'yes'",
              expires: 900,
              relativeId: 'what',
              version: '4',
              validations: {
                required: true,
              },
              label:
                'Vilka andra läkemedel är du allergisk mot, eller har fått biverkningar av?',
              index: '0.1.67.1',
            },
          ],
          extras: {},
          index: '0.1.67',
        },
        {
          id: 'allergy.other',
          type: 'composite',
          version: '2-complex',
          children: [
            {
              id: 'allergy.other.any',
              type: 'binary',
              expires: 180,
              relativeId: 'any',
              version: '2-complex',
              validations: {
                required: true,
              },
              label: 'Har du några andra kända allergier?',
              description: 'T.ex. husdjur eller pollen.',
              index: '0.1.68.0',
            },
            {
              id: 'allergy.other.what',
              type: 'multipleChoice',
              condition: "get('answers.allergy.other.any') === 'yes'",
              expires: 900,
              options: [
                {
                  value: 'pollen',
                  label: 'Pollen',
                },
                {
                  value: 'fur',
                  label: 'Pälsdjur',
                },
                {
                  value: 'mite',
                  label: 'Kvalster',
                },
                {
                  value: 'food',
                  label: 'Födoämnen',
                },
                {
                  value: 'other',
                  label: 'Annat',
                },
              ],
              validations: {
                required: true,
              },
              relativeId: 'what',
              version: '2-complex',
              label: 'Vad är du allergisk mot?',
              description: 'Flera svarsalternativ möjliga.',
              index: '0.1.68.1',
            },
            {
              id: 'allergy.other.other',
              type: 'text',
              condition: "contains(get('answers.allergy.other.what'), 'other')",
              expires: 900,
              relativeId: 'other',
              version: '2-complex',
              validations: {
                required: true,
              },
              label: 'Vad är du allergisk mot?',
              index: '0.1.68.2',
            },
          ],
          extras: {},
          index: '0.1.68',
        },
        {
          id: 'otherChoice',
          version: '2-expiry',
          type: 'binary',
          expires: 99999,
          validations: {
            required: true,
          },
          label: 'Övrigt',
          description:
            'Finns det något mer angående din allmänna hälsostatus som du tror att läkaren kan behöva veta?',
          index: '0.1.69',
        },
        {
          id: 'other',
          version: '3-expiry',
          type: 'text',
          expires: 99999,
          condition: "get('answers.otherChoice') === 'yes'",
          validations: {
            required: true,
          },
          label:
            'Vad mer angående din allmänna hälsostatus skulle du vilja förmedla till läkaren?',
          index: '0.1.70',
        },
      ],
      index: '0.1',
    },
    {
      id: 'predefined.age',
      type: 'predefined',
      version: '1',
      validations: {
        required: true,
      },
      index: '0.2',
    },
    {
      id: 'predefined.gender',
      type: 'predefined',
      version: '1',
      validations: {
        required: true,
      },
      index: '0.3',
    },
  ],
  variables: [
    {
      id: 'uti.pregnant',
      type: 'abort',
      expression: "get('answers.reproduction.pregnant') === 'yes'",
      relativeId: 'pregnant',
      version: '1',
      validations: {
        required: true,
      },
    },
    {
      id: 'uti.backPainAndFever',
      type: 'abort',
      expression:
        "get('answers.health.fever') === 'yes' && contains(['both', 'right', 'left'], get('answers.uti.backPain'))",
      relativeId: 'backPainAndFever',
      version: '1',
      validations: {
        required: true,
      },
    },
    {
      id: 'uti.antibiotics3in12',
      type: 'abort',
      expression:
        "get('answers.uti.recentAntibioticsYear.frequency') === 'threeOrMore'",
      relativeId: 'antibiotics3in12',
      version: '1',
      validations: {
        required: true,
      },
    },
    {
      id: 'uti.antibiotics2in6',
      type: 'abort',
      expression:
        "get('answers.uti.recentAntibioticsYear.twiceInSixMonths') === 'yes'",
      relativeId: 'antibiotics2in6',
      version: '1',
      validations: {
        required: true,
      },
    },
    {
      id: 'uti.utiEasilyAsssessed',
      type: 'caseType',
      expression:
        "get('answers.reproduction.pregnant') !== 'yes' && get('answers.reproduction.breastfeeding') !== 'yes' && get('answers.uti.recentAntibioticsYear.frequency') !== 'threeOrMore' && get('answers.uti.recentAntibioticsYear.twiceInSixMonths') !== 'yes' && get('answers.uti.recentAntibiotics.match') !== 'yes' && get('answers.started') !== 'moreThan4days' && get('answers.health.fever') === 'no' && get('answers.uti.selfTest') === 'no' && get('answers.health.pyelonephritis.match') === 'no' && ( (get('answers.uti.urgeToPee') === 'yes' ? 1 : 0) + (get('answers.health.peeingOften.match') === 'yes' ? 1 : 0) + (get('answers.uti.burnWhenPeeing') === 'yes' ? 1 : 0) ) >= 2 && get('answers.uti.problemLevel') !== 'mild' && get('answers.uti.backPain') === 'no' && get('answers.uti.blisters') !== 'yes' && get('answers.uti.itching') === 'no' && get('answers.uti.increasedDischarge') === 'no' && get('answers.uti.bloodInUrine.match') === 'no' && get('answers.problem.main') === 'uti' && get('answers.doctor.desiredHelpChoice') === 'treatment' && get('answers.otherChoice') === 'no' && get('answers.allergy.penicillinMatch') === 'no' && length(get('answers.health.issues.what')) < 1",
      relativeId: 'utiEasilyAsssessed',
      version: '1',
      validations: {
        required: true,
      },
    },
    {
      id: 'uti.bmi',
      type: 'number',
      expression:
        "(get('answers.height') < 1 ? 1 : get('answers.weight') * (get('answers.height') < 50 ? 1 : 10000) / (get('answers.height') * get('answers.height')))",
      relativeId: 'bmi',
      version: '1',
      validations: {
        required: true,
      },
    },
  ],
  views: {
    clinic: {
      children: [
        {
          id: 'problem.main',
          condition: "get('answers.problem.main') === 'uti'",
          type: 'question',
          version: '1',
          extras: {},
          label: 'Huvudsakligt besvär',
          description: '',
          options: [
            {
              value: 'uti',
              label: 'Jag misstänker att jag har urinvägsinfektion',
            },
            {
              value: 'other',
              label: 'Annat',
            },
          ],
        },
        {
          id: 'problem.mainOther',
          type: 'question',
          version: '1',
          extras: {},
          label: 'Huvudsakligt besvär',
          description: '',
        },
        {
          id: 'doctor.desiredHelpChoice',
          condition: "get('answers.doctor.desiredHelpChoice') === 'treatment'",
          type: 'question',
          version: '1',
          extras: {},
          label: 'Önskar hjälp med',
          description: '',
          options: [
            {
              value: 'treatment',
              label: 'Rådgivning och eventuell behandling',
            },
            {
              value: 'other',
              label: 'Annat',
            },
          ],
        },
        {
          id: 'doctor.desiredHelp',
          type: 'question',
          version: '1',
          extras: {},
          label: 'Önskar hjälp med',
          description: '',
        },
        {
          id: 'reproduction.pregnant',
          condition: "get('answers.reproduction.pregnant') === 'yes'",
          type: 'question',
          version: '1',
          extras: {},
          label: 'Gravid',
          description: '',
        },
        {
          id: 'reproduction.breastfeeding',
          condition: "get('answers.reproduction.breastfeeding') === 'yes'",
          type: 'question',
          version: '1',
          extras: {},
          label: 'Ammar',
          description: '',
        },
        {
          id: 'started',
          type: 'question',
          version: '1',
          extras: {},
          label: 'Besvären började',
          description: '',
          options: [
            {
              value: 'within24hours',
              label: 'Senaste dygnet',
            },
            {
              value: 'last2to4days',
              label: 'För 2–4 dagar sedan',
            },
            {
              value: 'moreThan4days',
              label: 'För mer än 4 dagar sedan',
            },
          ],
        },
        {
          id: 'uti.backPain',
          condition: "get('answers.uti.backPain') !== 'no'",
          type: 'question',
          version: '1',
          extras: {},
          label: 'Ryggont i samband med urinvägsbesvären',
          description: '',
          options: [
            {
              value: 'both',
              label: 'Ja, på båda sidor',
            },
            {
              value: 'right',
              label: 'Ja, på höger sida',
            },
            {
              value: 'left',
              label: 'Ja, på vänster sida',
            },
            {
              value: 'no',
              label: 'Nej',
            },
          ],
        },
        {
          id: 'health.fever',
          condition: "get('answers.health.fever') === 'yes'",
          type: 'question',
          version: '1',
          extras: {},
          label: 'Feber',
        },
        {
          id: 'health.temperature',
          type: 'question',
          version: '1',
          extras: {},
          label: 'Temperatur',
          unit: '°C',
        },
        {
          id: 'medication.recentAgainstFever',
          condition: "get('answers.medication.recentAgainstFever') === 'yes'",
          type: 'question',
          version: '1',
          extras: {},
          label: 'Tagit febernedsättande under de senaste 4 timmarna',
        },
        {
          id: 'uti.recentAntibioticsYear.match',
          condition: "get('answers.uti.recentAntibioticsYear.match') === 'yes'",
          type: 'question',
          version: '1',
          extras: {},
          label:
            'Behandlats med antibiotika mot UVI under senaste 12 månaderna',
        },
        {
          id: 'uti.recentAntibioticsYear.frequency',
          type: 'question',
          version: '1',
          extras: {},
          label:
            'Antal gånger pat behandlats med antibiotika mot UVI under senaste 12 månaderna',
          options: [
            {
              value: 'once',
              label: 'En gång',
            },
            {
              value: 'twice',
              label: 'Två gånger',
            },
            {
              value: 'threeOrMore',
              label: 'Tre gånger eller fler',
            },
          ],
        },
        {
          id: 'uti.recentAntibioticsYear.twiceInSixMonths',
          condition:
            "get('answers.uti.recentAntibioticsYear.twiceInSixMonths') === 'yes'",
          type: 'question',
          version: '1',
          extras: {},
          label: 'Fått båda behandlingarna under senaste 6 månaderna',
        },
        {
          id: 'uti.recentAntibiotics.match',
          condition: "get('answers.uti.recentAntibiotics.match') === 'yes'",
          type: 'question',
          version: '1',
          extras: {},
          label: 'Behandlats med antibiotika mot UVI under senaste månaden',
        },
        {
          id: 'uti.recentAntibiotics.what',
          condition: "get('answers.uti.recentAntibiotics.what') !== 'other'",
          type: 'question',
          version: '1',
          extras: {},
          label: 'Antibiotikabehandlad med',
          options: [
            {
              value: 'selexid',
              label: 'Pivmecillinam (t.ex. Selexid, Penomax)',
            },
            {
              value: 'cefadroxil',
              label: 'Cefadroxil (t.ex. Cefamox)',
            },
            {
              value: 'furadantin',
              label: 'Nitrofurantoin (t.ex. Furadantin)',
            },
            {
              value: 'trimetoprim',
              label: 'Trimetoprim (t.ex. Idotrim)',
            },
            {
              value: 'ciprofloxacin',
              label: 'Ciprofloxacin (t.ex. Ciproxin)',
            },
            {
              value: 'other',
              label: 'Annat',
            },
          ],
        },
        {
          id: 'uti.recentAntibiotics.other',
          type: 'question',
          version: '1',
          extras: {},
          label: 'Antibiotikabehandlad med, annat',
        },
        {
          id: 'uti.recentAntibiotics.when',
          type: 'question',
          version: '1',
          extras: {},
          label: 'Antibiotikabehandling påbörjad',
          description: '',
          options: [
            {
              value: 'within24hours',
              label: 'Senaste dygnet',
            },
            {
              value: 'last2to4days',
              label: 'För 2–4 dagar sedan',
            },
            {
              value: 'moreThan4days',
              label: 'För mer än 4 dagar sedan',
            },
          ],
        },
        {
          id: 'health.pyelonephritis.match',
          condition: "get('answers.health.pyelonephritis.match') === 'yes'",
          type: 'question',
          version: '1',
          extras: {},
          label: 'Tidigare haft njurbäckeninflammation',
        },
        {
          id: 'uti.burnWhenPeeing',
          condition: "get('answers.uti.burnWhenPeeing') === 'yes'",
          type: 'question',
          version: '1',
          extras: {},
          label: 'Sveda vid urinering',
          description: '',
        },
        {
          id: 'uti.urgeToPee',
          condition: "get('answers.uti.urgeToPee') === 'yes'",
          type: 'question',
          version: '1',
          extras: {},
          label: 'Upplever trängningar',
        },
        {
          id: 'health.peeingOften.match',
          condition: "get('answers.health.peeingOften.match') === 'yes'",
          type: 'question',
          version: '1',
          extras: {},
          label: 'Frekventa miktioner',
        },
        {
          id: 'uti.problemLevel',
          type: 'question',
          version: '1',
          extras: {},
          label: 'Upplever urinvägsbesvären som',
          options: [
            {
              value: 'mild',
              label: 'Jag har lindriga besvär.',
            },
            {
              value: 'moderate',
              label: 'Jag har måttliga besvär.',
            },
            {
              value: 'severe',
              label: 'Jag har kraftiga besvär.',
            },
          ],
        },
        {
          id: 'uti.bloodInUrine.match',
          condition: "get('answers.uti.bloodInUrine.match') !== 'no'",
          type: 'question',
          version: '1',
          extras: {},
          label: 'Synligt blod i urinen',
          description: '',
          options: [
            {
              value: 'yesRed',
              label: 'Ja, urinen är rödfärgad.',
            },
            {
              value: 'yesLumps',
              label: 'Ja, jag har blodklumpar i urinen.',
            },
            {
              value: 'yesRedAndLumps',
              label:
                'Ja, jag har både rödfärgad urin och blodklumpar i urinen.',
            },
            {
              value: 'no',
              label: 'Nej',
            },
          ],
        },
        {
          id: 'uti.bloodInUrine.duration',
          type: 'question',
          version: '1',
          extras: {},
          label: 'Blod i urinen sedan',
          description: '',
          options: [
            {
              value: 'within24hours',
              label: 'Senaste dygnet',
            },
            {
              value: 'twoToFourDays',
              label: '2–4 dagar',
            },
            {
              value: 'moreThanFourDays',
              label: 'I mer än 4 dagar',
            },
          ],
        },
        {
          id: 'uti.bloodInUrine.previous',
          condition: "get('answers.uti.bloodInUrine.previous') === 'yes'",
          type: 'question',
          version: '1',
          extras: {},
          label: 'Haft synligt blod i urinen tidigare',
          description: '',
        },
        {
          id: 'reproduction.period.match',
          condition: "get('answers.reproduction.period.match') === 'yes'",
          type: 'question',
          version: '1',
          extras: {},
          label: 'Mens just nu',
          description: '',
        },
        {
          id: 'gastric.painLowerAbdomen',
          condition: "get('answers.gastric.painLowerAbdomen') === 'yes'",
          type: 'question',
          version: '1',
          extras: {},
          label: 'Ont i nedre delen av magen',
          description: '',
        },
        {
          id: 'uti.itching',
          condition: "get('answers.uti.itching') === 'yes'",
          type: 'question',
          version: '1',
          extras: {},
          label: 'Klåda i underlivet',
          description: '',
        },
        {
          id: 'uti.increasedDischarge',
          condition: "get('answers.uti.increasedDischarge') === 'yes'",
          type: 'question',
          version: '1',
          extras: {},
          label: 'Ökade flytningar',
          description: '',
        },
        {
          id: 'uti.blisters',
          condition: "get('answers.uti.blisters') === 'yes'",
          type: 'question',
          version: '1',
          extras: {},
          label: 'Blåsor i underlivet',
          description: '',
        },
        {
          id: 'medication.containing.estrogen.ongoing.match',
          condition:
            "get('answers.medication.containing.estrogen.ongoing.match') === 'yes'",
          type: 'question',
          version: '1',
          extras: {},
          label: 'Använder läkemedel med östrogen',
        },
        {
          id: 'uti.selfTest',
          condition: "get('answers.uti.selfTest') !== 'no'",
          type: 'question',
          version: '1',
          extras: {},
          label: 'Gjort självtest för UVI',
          description: '',
          options: [
            {
              value: 'positive',
              label: 'Ja, med positivt resultat',
            },
            {
              value: 'negative',
              label: 'Ja, med negativt resultat',
            },
            {
              value: 'no',
              label: 'Nej',
            },
          ],
        },
        {
          id: 'occupation.current.what',
          condition: 'false',
          type: 'question',
          version: '1',
          extras: {},
          label: 'Huvudsaklig sysselsättning',
          options: [
            {
              value: 'working',
              label: 'Arbetar',
            },
            {
              value: 'student',
              label: 'Studerar',
            },
            {
              value: 'sicklisted',
              label: 'Sjukskriven',
            },
            {
              value: 'parentalleave',
              label: 'Föräldraledig',
            },
            {
              value: 'retired',
              label: 'Pensionär',
            },
            {
              value: 'jobseeking',
              label: 'Arbetssökande',
            },
            {
              value: 'other',
              label: 'Annat',
            },
          ],
        },
        {
          id: 'work.what',
          condition: 'false',
          type: 'question',
          version: '1',
          extras: {},
          label: 'Arbetar med',
        },
        {
          id: 'occupation.sicklisted',
          condition: 'false',
          type: 'question',
          version: '1',
          extras: {},
          label: 'Anledning till sjukskrivning',
        },
        {
          id: 'occupation.sicklistedSince',
          condition: 'false',
          type: 'question',
          version: '1',
          extras: {},
          label: 'Senaste sjukskrivningsperiod påbörjad datum',
        },
        {
          id: 'occupation.current.other',
          condition: 'false',
          type: 'question',
          version: '1',
          extras: {},
          label: 'Annan huvudsaklig sysselsättning',
        },
        {
          id: 'height',
          condition: 'false',
          type: 'question',
          version: '1',
          extras: {},
          label: 'Längd',
          unit: 'cm',
        },
        {
          id: 'weight',
          condition:
            "get('answers.weight') < 50 || get('answers.weight') >= 110",
          type: 'question',
          version: '1',
          extras: {},
          label: 'Vikt',
          unit: 'kg',
        },
        {
          id: 'clinic.bmitext',
          type: 'text',
          warning:
            "get('variables.uti.bmi') >= 35 || (get('variables.uti.bmi') > 1 && get('variables.uti.bmi') < 17)",
          version: '1',
          validations: {
            required: true,
          },
          label: 'BMI',
          template:
            "((!get('variables.uti.bmi') || get('variables.uti.bmi') < 2) ? '-' : (get('variables.uti.bmi')).toFixed(1) + ' ' + (get('variables.uti.bmi') < 18.5 ? '(Undervikt)' : (get('variables.uti.bmi') < 25 ? '(Normalvikt)' : (get('variables.uti.bmi') < 30 ? '(Övervikt)' : '(Fetma)'))))",
        },
        {
          id: 'smoking.status',
          condition:
            "get('answers.smoking.status') === 1 || get('answers.smoking.status') === 3",
          type: 'question',
          version: '1',
          extras: {},
          label: 'Rökning',
          options: [
            {
              value: 1,
              label: 'Ja',
            },
            {
              value: 2,
              label: 'Nej',
            },
            {
              value: 3,
              label: 'Före detta',
            },
          ],
        },
        {
          id: 'smoking.amount',
          condition: 'false',
          type: 'question',
          version: '1',
          extras: {},
          label: 'Antal cigaretter/dag',
          options: [
            {
              value: 'lessthan10',
              label: 'Färre än tio',
            },
            {
              value: 'more',
              label: 'Tio eller fler',
            },
          ],
        },
        {
          id: 'alcohol.amountFemale',
          condition: 'false',
          type: 'question',
          version: '1',
          extras: {},
          label: 'Alkoholkonsumtion',
          description: '',
          options: [
            {
              value: 'more',
              label: '9 standardglas i veckan eller mer',
            },
            {
              value: 'less',
              label: 'Mindre än 9 standardglas i veckan',
            },
            {
              value: 'none',
              label: 'Jag dricker inte alkohol',
            },
          ],
        },
        {
          id: 'health.issues.what',
          condition: "get('answers.health.issues.what') !== undefined",
          warning:
            "contains(get('answers.health.issues.what'), 'kidney') || contains(get('answers.health.issues.what'), 'liver')",
          type: 'question',
          version: '1',
          extras: {},
          label: 'Tidigare och/eller nuvarande sjukdomar',
          description: '',
          options: [
            {
              value: 'bloodpreassure',
              label: 'Högt blodtryck med tablettbehandling',
            },
            {
              value: 'cardiovascular',
              label: 'Hjärt-kärlsjukdom',
            },
            {
              value: 'diabetes',
              label: 'Diabetes',
            },
            {
              value: 'lungs',
              label: 'Lungsjukdom',
            },
            {
              value: 'cancer',
              label: 'Cancersjukdom',
            },
            {
              value: 'neuro',
              label: 'Neurologisk sjukdom',
            },
            {
              value: 'blooddisease',
              label: 'Blodsmitta (HIV, Hepatit B, Hepatit C)',
            },
            {
              value: 'kidney',
              label: 'Njurfunktionsnedsättning',
            },
            {
              value: 'liver',
              label: 'Leverfunktionsnedsättning',
            },
          ],
        },
        {
          id: 'health.cardiovascular.what.what',
          type: 'question',
          version: '1',
          extras: {},
          label: 'Hjärt-kärlsjukdom',
          options: [
            {
              value: 'infarction',
              label: 'Hjärtinfarkt',
            },
            {
              value: 'congestiveHeart',
              label: 'Hjärtsvikt',
            },
            {
              value: 'anginaPectoris',
              label: 'Kärlkramp',
            },
            {
              value: 'atrialFibrillation',
              label: 'Förmaksflimmer',
            },
            {
              value: 'heartValve',
              label: 'Hjärtklaffsfel',
            },
            {
              value: 'stroke',
              label: 'Stroke',
            },
            {
              value: 'bloodClot',
              label: 'Blodpropp som krävt blodförtunnande medicinering',
            },
            {
              value: 'other',
              label: 'Annan hjärt-kärlsjukdom',
            },
          ],
        },
        {
          id: 'health.cardiovascular.what.other',
          type: 'question',
          version: '1',
          extras: {},
          label: 'Fri beskrivning annan hjärt-kärlsjukdom',
        },
        {
          id: 'health.diabetes.type',
          warning:
            "contains(get('answers.health.diabetes.type'), 'type1') || contains(get('answers.health.diabetes.type'), 'type2')",
          type: 'question',
          version: '1',
          extras: {},
          label: 'Typ av diabetes',
          description: '',
          options: [
            {
              value: 'type1',
              label: 'Diabetes typ 1',
            },
            {
              value: 'type2',
              label: 'Diabetes typ 2',
            },
            {
              value: 'other',
              label: 'Annat',
            },
          ],
        },
        {
          id: 'health.diabetes.typeOther',
          type: 'question',
          version: '1',
          extras: {},
          label: 'Typ av diabetes, annat',
          description: '',
        },
        {
          id: 'health.diabetes.treatment',
          type: 'question',
          version: '1',
          extras: {},
          label: 'Diabetes behandlas med',
          description: '',
          options: [
            {
              value: 'food',
              label: 'Kostbehandling',
            },
            {
              value: 'pills',
              label: 'Tablettbehandling',
            },
            {
              value: 'insuline',
              label: 'Insulinbehandling',
            },
          ],
        },
        {
          id: 'health.lungDiseases.what.what',
          type: 'question',
          version: '1',
          extras: {},
          label: 'Lungsjukdom',
          description: '',
          options: [
            {
              value: 'astma',
              label: 'Astma',
            },
            {
              value: 'kol',
              label: 'KOL',
            },
            {
              value: 'other',
              label: 'Annan lungsjukdom',
            },
          ],
        },
        {
          id: 'health.lungDiseases.what.other',
          type: 'question',
          version: '1',
          extras: {},
          label: 'Fri beskrivning annan lungsjukdom',
        },
        {
          id: 'health.cancerWhat',
          type: 'question',
          version: '1',
          extras: {},
          label: 'Cancersjukdom',
        },
        {
          id: 'health.cancerYearDiagnosed',
          type: 'question',
          version: '1',
          extras: {},
          label: 'Diagnosticerad (cancer)',
        },
        {
          id: 'health.cancerAffected.match',
          warning: "get('answers.health.cancerAffected.match') === 'yes'",
          type: 'question',
          version: '1',
          extras: {},
          label: 'Har aktuella besvär på grund av cancer',
        },
        {
          id: 'health.cancerAffected.how',
          type: 'question',
          version: '1',
          extras: {},
          label: 'Beskrivning av aktuella besvär på grund av cancer',
        },
        {
          id: 'health.neurological.what.what',
          type: 'question',
          version: '1',
          extras: {},
          label: 'Neurologisk sjukdom',
          options: [
            {
              value: 'epilepsy',
              label: 'Epilepsi',
            },
            {
              value: 'ms',
              label: 'MS',
            },
            {
              value: 'parkinson',
              label: 'Parkinson',
            },
            {
              value: 'other',
              label: 'Annan neurologisk sjukdom',
            },
          ],
        },
        {
          id: 'health.neurological.what.other',
          type: 'question',
          version: '1',
          extras: {},
          label: 'Fri beskrivning annan neurologisk sjukdom',
        },
        {
          id: 'health.bloodDisease.what',
          warning: "contains(get('answers.health.bloodDisease.what'), 'hiv')",
          type: 'question',
          version: '1',
          extras: {},
          label: 'Blodsmitta',
          options: [
            {
              value: 'hepB',
              label: 'Hepatit B',
            },
            {
              value: 'hepC',
              label: 'Hepatit C',
            },
            {
              value: 'hiv',
              label: 'HIV',
            },
          ],
        },
        {
          id: 'health.operation.match',
          condition: "get('answers.health.operation.match') === 'yes'",
          type: 'question',
          version: '1',
          extras: {},
          label: 'Har genomgått större operation',
        },
        {
          id: 'health.operation.what',
          type: 'question',
          version: '1',
          extras: {},
          label: 'Beskrivning av operation',
        },
        {
          id: 'health.relativesCancer',
          condition: 'false',
          type: 'question',
          version: '1',
          extras: {},
          label: 'Förälder/syskon drabbad av cancer',
        },
        {
          id: 'health.relativesCardiovascular',
          condition: 'false',
          type: 'question',
          version: '1',
          extras: {},
          label: 'Förälder/syskon drabbad av hjärt-kärlsjukdom',
        },
        {
          id: 'health.relativesDiabetes',
          condition: 'false',
          type: 'question',
          version: '1',
          extras: {},
          label: 'Förälder/syskon drabbad av diabetes',
        },
        {
          id: 'medication.current.anyFemale',
          type: 'question',
          version: '1',
          extras: {},
          label: 'Tar läkemedel för tillfället',
          description: '(inklusive ev. hormonella preventivmedel)',
        },
        {
          id: 'medication.current.what',
          type: 'question',
          version: '1',
          extras: {},
          label: 'Beskrivning av läkemedel',
          description: '',
        },
        {
          id: 'medication.packaged',
          condition: "get('answers.medication.packaged') === 'yes'",
          warning: "get('answers.medication.packaged') === 'yes'",
          type: 'question',
          version: '1',
          extras: {},
          label: 'Har dosförpackade läkemedel',
          description: '',
        },
        {
          id: 'medication.deliveryHelp.match',
          condition: "get('answers.medication.deliveryHelp.match') === 'yes'",
          warning: "get('answers.medication.deliveryHelp.match') === 'yes'",
          type: 'question',
          version: '1',
          extras: {},
          label: 'Får hjälp med utdelning av läkemedel',
          description: '',
        },
        {
          id: 'medication.deliveryHelp.what',
          type: 'question',
          version: '1',
          extras: {},
          label: 'Typ av hjälp med utdelning av läkemedel',
          description: '',
        },
        {
          id: 'medication.naturopathic.any',
          condition: "get('answers.medication.naturopathic.any') === 'yes'",
          type: 'question',
          version: '1',
          extras: {},
          label: 'Använder natur- eller hälsokostpreparat för tillfället',
          description: '',
        },
        {
          id: 'medication.naturopathic.what',
          type: 'question',
          version: '1',
          extras: {},
          label: 'Vilka natur- eller hälsokostpreparat',
          description: '',
        },
        {
          id: 'allergy.penicillinMatch',
          warning: "contains(get('answers.allergy.penicillinMatch'), 'yes')",
          type: 'question',
          version: '1',
          extras: {},
          label: 'Har penicillin/antibiotikaallergi',
          description: '',
          options: [
            {
              value: 'yesKnows',
              label:
                'Ja, och jag vet vilken sorts penicillin eller antibiotika jag är allergisk mot.',
            },
            {
              value: 'yesDontKnow',
              label:
                'Ja, men jag vet inte vilken sorts penicillin eller antibiotika jag är allergisk mot.',
            },
            {
              value: 'no',
              label: 'Nej',
            },
            {
              value: 'dontKnow',
              label: 'Vet ej',
            },
          ],
        },
        {
          id: 'allergy.penicillinWhat',
          type: 'question',
          version: '1',
          extras: {},
          label: 'Typ av penicillin/antibiotikaallergi',
          description: '',
          options: [
            {
              value: 'penicillins',
              label:
                'Penicilliner (t.ex. Amimox, Amoxicillin, Avopenin, Bioclavid, Calciopen, Flukloxacillin, Imacillin, Heracillin, Klaximol, Kåvepenin, Penomax, Selexid, Spektramox, Tikacillin)',
            },
            {
              value: 'azitromycin',
              label: 'Azitromycin (t.ex. Azitromax)',
            },
            {
              value: 'cefadroxil',
              label: 'Cefadroxil (t.ex. Cefamox)',
            },
            {
              value: 'ciprofloxacin',
              label: 'Ciprofloxacin (t.ex. Ciproxin)',
            },
            {
              value: 'erytromycin',
              label: 'Erytromycin (t.ex. Abboticin, Ery-Max)',
            },
            {
              value: 'klindamycin',
              label: 'Klindamycin (t.ex. Dalacin)',
            },
            {
              value: 'nitrofurantoin',
              label: 'Nitrofurantoin (t.ex. Furadantin)',
            },
            {
              value: 'norfloxacin',
              label: 'Norfloxacin (t.ex. Lexinor)',
            },
            {
              value: 'sulfa',
              label:
                'Sulfa (t.ex. Bactrim, Bactrim forte, Eusaprim, Eusaprim forte)',
            },
            {
              value: 'tetracykliner',
              label:
                'Tetracykliner (t.ex. Doxyferm, Lymelysal, Tetracyklin, Tetralysal)',
            },
            {
              value: 'trimetoprim',
              label: 'Trimetoprim (t.ex. Idotrim)',
            },
            {
              value: 'other',
              label: 'Annat',
            },
          ],
        },
        {
          id: 'allergy.penicillinOther',
          type: 'question',
          version: '1',
          extras: {},
          label: 'Annan typ av penicillin/antibiotikaallergi',
          description: '',
        },
        {
          id: 'allergy.penicillinReaction',
          type: 'question',
          version: '1',
          extras: {},
          label: 'Reaktion vid penicillin/antibiotikaallergi',
          description: '',
          options: [
            {
              value: 'severe',
              label:
                'Allvarlig reaktion med t.ex. andningssvårigheter och svullnad i mun och svalg',
            },
            {
              value: 'light',
              label: 'Lättare besvär såsom hudutslag och klåda',
            },
            {
              value: 'other',
              label: 'Annat',
            },
          ],
        },
        {
          id: 'allergy.penicillinReactionOther',
          type: 'question',
          version: '1',
          extras: {},
          label: 'Fri beskrivning annan reaktion',
          description: '',
        },
        {
          id: 'allergy.medication.any',
          condition:
            "get('answers.allergy.medication.any') === 'yes' || get('answers.allergy.medication.any') === 'no'",
          warning: "get('answers.allergy.medication.any') === 'yes'",
          type: 'question',
          version: '1',
          extras: {},
          label: 'Har övriga medicinallergier',
          description: '',
        },
        {
          id: 'allergy.medication.what',
          type: 'question',
          version: '1',
          extras: {},
          label: 'Beskrivning av övriga medicinallergier',
          description: '',
        },
        {
          id: 'allergy.other.any',
          type: 'question',
          version: '1',
          extras: {},
          label: 'Andra allergier',
          description: '',
        },
        {
          id: 'allergy.other.what',
          condition:
            "contains(get('answers.allergy.other.what'), 'food') || contains(get('answers.allergy.other.what'), 'other')",
          type: 'question',
          version: '1',
          extras: {},
          label: 'Andra allergier',
          description: '',
          options: [
            {
              value: 'pollen',
              label: 'Pollen',
            },
            {
              value: 'fur',
              label: 'Pälsdjur',
            },
            {
              value: 'mite',
              label: 'Kvalster',
            },
            {
              value: 'food',
              label: 'Födoämnen',
            },
            {
              value: 'other',
              label: 'Annat',
            },
          ],
        },
        {
          id: 'allergy.other.other',
          type: 'question',
          version: '1',
          extras: {},
          label: 'Fri beskrivning andra allergier',
          description: '',
        },
        {
          id: 'otherChoice',
          condition: "get('answers.otherChoice') === 'yes'",
          type: 'question',
          version: '1',
          extras: {},
          label: 'Övrigt',
          description: '',
        },
        {
          id: 'other',
          type: 'question',
          version: '1',
          extras: {},
          label: 'Övrigt',
          description: '',
        },
      ],
      type: 'view',
      version: '1',
      validations: {
        required: true,
      },
    },
    prescriptionwarnings: {
      children: [
        {
          id: 'reproduction.pregnant',
          condition: "get('answers.reproduction.pregnant') === 'yes'",
          warning: 'true',
          type: 'question',
          version: '1',
          extras: {},
          label: 'Gravid',
          description: '',
        },
        {
          id: 'reproduction.breastfeeding',
          condition: "get('answers.reproduction.breastfeeding') === 'yes'",
          warning: 'true',
          type: 'question',
          version: '1',
          extras: {},
          label: 'Ammar',
          description: '',
        },
        {
          id: 'prescriptionwarnings.liverFunctions',
          type: 'text',
          condition: "contains(get('answers.health.issues.what'), 'liver')",
          warning: 'true',
          version: '1',
          validations: {
            required: true,
          },
          label: 'Nedsatt leverfunktion',
          description: '',
          template: "'Ja'",
        },
        {
          id: 'prescriptionwarnings.kidneyFunctions',
          type: 'text',
          condition: "contains(get('answers.health.issues.what'), 'kidney')",
          warning: 'true',
          version: '1',
          validations: {
            required: true,
          },
          label: 'Nedsatt njurfunktion',
          description: '',
          template: "'Ja'",
        },
        {
          id: 'allergy.penicillinMatch',
          condition: "contains(get('answers.allergy.penicillinMatch'), 'yes')",
          warning: 'true',
          type: 'question',
          version: '1',
          extras: {},
          label: 'Har penicillin/antibiotikaallergi',
          description: '',
          options: [
            {
              value: 'yesKnows',
              label:
                'Ja, och jag vet vilken sorts penicillin eller antibiotika jag är allergisk mot.',
            },
            {
              value: 'yesDontKnow',
              label:
                'Ja, men jag vet inte vilken sorts penicillin eller antibiotika jag är allergisk mot.',
            },
            {
              value: 'no',
              label: 'Nej',
            },
            {
              value: 'dontKnow',
              label: 'Vet ej',
            },
          ],
        },
        {
          id: 'allergy.penicillinWhat',
          condition: "get('answers.allergy.penicillinMatch') === 'yesKnows'",
          type: 'question',
          version: '1',
          extras: {},
          label: 'Typ av penicillin/antibiotikaallergi',
          description: '',
          options: [
            {
              value: 'penicillins',
              label:
                'Penicilliner (t.ex. Amimox, Amoxicillin, Avopenin, Bioclavid, Calciopen, Flukloxacillin, Imacillin, Heracillin, Klaximol, Kåvepenin, Penomax, Selexid, Spektramox, Tikacillin)',
            },
            {
              value: 'azitromycin',
              label: 'Azitromycin (t.ex. Azitromax)',
            },
            {
              value: 'cefadroxil',
              label: 'Cefadroxil (t.ex. Cefamox)',
            },
            {
              value: 'ciprofloxacin',
              label: 'Ciprofloxacin (t.ex. Ciproxin)',
            },
            {
              value: 'erytromycin',
              label: 'Erytromycin (t.ex. Abboticin, Ery-Max)',
            },
            {
              value: 'klindamycin',
              label: 'Klindamycin (t.ex. Dalacin)',
            },
            {
              value: 'nitrofurantoin',
              label: 'Nitrofurantoin (t.ex. Furadantin)',
            },
            {
              value: 'norfloxacin',
              label: 'Norfloxacin (t.ex. Lexinor)',
            },
            {
              value: 'sulfa',
              label:
                'Sulfa (t.ex. Bactrim, Bactrim forte, Eusaprim, Eusaprim forte)',
            },
            {
              value: 'tetracykliner',
              label:
                'Tetracykliner (t.ex. Doxyferm, Lymelysal, Tetracyklin, Tetralysal)',
            },
            {
              value: 'trimetoprim',
              label: 'Trimetoprim (t.ex. Idotrim)',
            },
            {
              value: 'other',
              label: 'Annat',
            },
          ],
        },
        {
          id: 'allergy.penicillinOther',
          condition: "contains(get('answers.allergy.penicillinWhat'), 'other')",
          type: 'question',
          version: '1',
          extras: {},
          label: 'Annan typ av penicillin/antibiotikaallergi',
          description: '',
        },
        {
          id: 'allergy.medication.any',
          condition: "get('answers.allergy.medication.any') === 'yes'",
          warning: 'true',
          type: 'question',
          version: '1',
          extras: {},
          label: 'Har övriga medicinallergier',
        },
        {
          id: 'allergy.medication.what',
          type: 'question',
          version: '1',
          extras: {},
          label: 'Beskrivning av övriga medicinallergier',
        },
        {
          id: 'medication.packaged',
          condition: "get('answers.medication.packaged') === 'yes'",
          warning: 'true',
          type: 'question',
          version: '1',
          extras: {},
          label: 'Har dosförpackade läkemedel',
          description: '',
        },
      ],
      type: 'view',
      version: '1',
      validations: {
        required: true,
      },
    },
    journalEntry: {
      children: [
        {
          id: 'contactReason',
          type: 'comment',
          version: '1',
          validations: {
            required: true,
          },
          label: 'journal.contactReason',
          description: 'Urinvägsbesvär',
        },
        {
          id: 'kidney',
          type: 'comment',
          condition: "contains(get('answers.health.issues.what'), 'kidney')",
          version: '1',
          validations: {
            required: true,
          },
          label: 'journal.anamnesis',
          description: 'Njurfunktionsnedsättning',
        },
        {
          id: 'liver',
          type: 'comment',
          condition: "contains(get('answers.health.issues.what'), 'liver')",
          version: '1',
          validations: {
            required: true,
          },
          label: 'journal.anamnesis',
          description: 'Leversfunktionsnedsättning',
        },
        {
          id: 'diabetesType1',
          type: 'comment',
          condition: "contains(get('answers.health.diabetes.type'), 'type1')",
          version: '1',
          validations: {
            required: true,
          },
          label: 'journal.anamnesis',
          description: 'Diabetes typ 1',
        },
        {
          id: 'diabetesType2',
          type: 'comment',
          condition: "contains(get('answers.health.diabetes.type'), 'type2')",
          version: '1',
          validations: {
            required: true,
          },
          label: 'journal.anamnesis',
          description: 'Diabetes typ 2',
        },
        {
          id: 'breastfeeding',
          type: 'comment',
          condition: "get('answers.reproduction.breastfeeding') === 'yes'",
          version: '1',
          validations: {
            required: true,
          },
          label: 'journal.current',
          description: 'Ammande kvinna',
        },
        {
          id: 'burnWhenPeeing',
          type: 'comment',
          condition: "get('answers.uti.burnWhenPeeing') === 'yes'",
          version: '1',
          validations: {
            required: true,
          },
          label: 'journal.current',
          description: 'Sveda',
        },
        {
          id: 'urgeToPee',
          type: 'comment',
          condition: "get('answers.uti.urgeToPee') === 'yes'",
          version: '1',
          validations: {
            required: true,
          },
          label: 'journal.current',
          description: 'Trängningar',
        },
        {
          id: 'peeingOften',
          type: 'comment',
          condition: "get('answers.health.peeingOften.match') === 'yes'",
          version: '1',
          validations: {
            required: true,
          },
          label: 'journal.current',
          description: 'Frekventa miktioner',
        },
        {
          id: 'started24Hours',
          type: 'comment',
          condition: "get('answers.started') === 'within24hours'",
          version: '1',
          validations: {
            required: true,
          },
          label: 'journal.current',
          description: 'Besvär senaste dygnet',
        },
        {
          id: 'started2to4Days',
          type: 'comment',
          condition: "get('answers.started') === 'last2to4days'",
          version: '1',
          validations: {
            required: true,
          },
          label: 'journal.current',
          description: 'Besvär sedan några dagar tillbaka',
        },
        {
          id: 'startedMoreThan4Days',
          type: 'comment',
          condition: "get('answers.started') === 'moreThan4days'",
          version: '1',
          validations: {
            required: true,
          },
          label: 'journal.current',
          description: 'Besvär i mer än 4 dagar',
        },
        {
          id: 'fever',
          type: 'comment',
          condition: "get('answers.health.fever') === 'yes'",
          version: '1',
          validations: {
            required: true,
          },
          label: 'journal.current',
          description: 'Feber över 38°C',
        },
        {
          id: 'nofever',
          type: 'comment',
          condition: "get('answers.health.fever') === 'no'",
          version: '1',
          validations: {
            required: true,
          },
          label: 'journal.current',
          description: 'Afebril',
        },
        {
          id: 'noBackPain',
          type: 'comment',
          condition: "get('answers.uti.backPain') === 'no'",
          version: '1',
          validations: {
            required: true,
          },
          label: 'journal.current',
          description: 'Ingen ryggsmärta',
        },
        {
          id: 'backPainBothSides',
          type: 'comment',
          condition: "get('answers.uti.backPain') === 'both'",
          version: '1',
          validations: {
            required: true,
          },
          label: 'journal.current',
          description: 'Bilateral ryggsmärta',
        },
        {
          id: 'backPainLeft',
          type: 'comment',
          condition: "get('answers.uti.backPain') === 'left'",
          version: '1',
          validations: {
            required: true,
          },
          label: 'journal.current',
          description: 'Vänstersidig ryggsmärta',
        },
        {
          id: 'backPainRight',
          type: 'comment',
          condition: "get('answers.uti.backPain') === 'right'",
          version: '1',
          validations: {
            required: true,
          },
          label: 'journal.current',
          description: 'Högersidig ryggsmärta',
        },
        {
          id: 'bloodInUrine',
          type: 'comment',
          condition: "get('answers.uti.bloodInUrine.match') === 'no'",
          version: '1',
          validations: {
            required: true,
          },
          label: 'journal.current',
          description: 'Ingen hematuri',
        },
        {
          id: 'UTIonceIn12Months',
          type: 'comment',
          condition:
            "get('answers.uti.recentAntibioticsYear.frequency') === 'once'",
          version: '1',
          validations: {
            required: true,
          },
          label: 'journal.current',
          description: 'Recidiverande UVI',
        },
        {
          id: 'UTItwiceIn12Months',
          type: 'comment',
          condition:
            "get('answers.uti.recentAntibioticsYear.frequency') === 'twice'",
          version: '1',
          validations: {
            required: true,
          },
          label: 'journal.current',
          description: 'Recidiverande UVI',
        },
        {
          id: 'antibioticsLastMonth',
          type: 'comment',
          condition: "get('answers.uti.recentAntibiotics.match') === 'yes'",
          version: '1',
          validations: {
            required: true,
          },
          label: 'journal.current',
          description: 'Antibiotikabehandlats mot UVI under de senaste månaden',
        },
        {
          id: 'followUp',
          type: 'comment',
          version: '1',
          validations: {
            required: true,
          },
          label: 'journal.followUp',
          description:
            'Patienten uppmanas att söka vård på nytt om förbättring uteblir, symptomen förvärras eller om nya symptom tillkommer.',
        },
      ],
      type: 'view',
      version: '1',
      validations: {
        required: true,
      },
    },
  },
  label: 'Urinvägsbesvär',
  index: '0',
};
